import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateService } from '../services/translate/custom-translate.service';
import { SharedModule } from '../shared/shared.module';
import { RequestInterceptor } from './auth/interceptors/request.interceptor';
import { ExchangeModalComponent } from './layout/layout/exchange-modal/exchange-modal.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { ModalErrorComponent } from './layout/modal-error/modal-error.component';
import { PageLayoutComponent } from './layout/page-layout/page-layout.component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CRMEffects } from 'src/app/store/effects/crm/crm.effects';
import * as fromCrm from '../store/reducers/crm/crm.reducer';

@NgModule({
  declarations: [
    LayoutComponent,
    PageLayoutComponent,
    ModalErrorComponent,
    ExchangeModalComponent
  ],
  imports: [
    SharedModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateService
        //useFactory: HttpLoaderFactory,
        //deps: [HttpClient]
      }
    }),
    StoreModule.forFeature(
      fromCrm.crmFeatureKey,
      fromCrm.reducer
    ),
    EffectsModule.forFeature([CRMEffects]),
  ],
  exports: [ModalErrorComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {}
